module.exports = __webpack_public_path__ + "src/img/zz.d27e6ff1.svg";